import { render, staticRenderFns } from "./resource-list.vue?vue&type=template&id=65b291fc&scoped=true&"
import script from "./resource-list.vue?vue&type=script&lang=js&"
export * from "./resource-list.vue?vue&type=script&lang=js&"
import style0 from "./resource-list.vue?vue&type=style&index=0&id=65b291fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b291fc",
  null
  
)

component.options.__file = "resource-list.vue"
export default component.exports